/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
export * from './site_eyebrow.js'
export * from './site_description.js'
export * from './home_title_line1.js'
export * from './home_title_line2.js'
export * from './home_pitch.js'
export * from './home_login_button.js'
export * from './home_login_in_progress.js'
export * from './home_dev_notice.js'
export * from './home_page_title.js'
export * from './callback_in_progress.js'
export * from './callback_error_label.js'
export * from './callback_back_to_home.js'
export * from './office_logout.js'
export * from './map_office.js'
export * from './map_hotel.js'
export * from './map_clinic.js'
export * from './map_airport_terminal.js'
export * from './map_triple_h1.js'
export * from './map_battle_royale.js'
export * from './map_campus.js'
export * from './map_switcher_label.js'
export * from './world_switcher_label.js'
export * from './world_switcher_switching.js'
export * from './world_switcher_eta.js'
export * from './world_switcher_error_title.js'
export * from './world_switcher_error_retry.js'
export * from './world_switcher_unknown.js'
export * from './tasks_button_label.js'
export * from './tasks_panel_title.js'
export * from './tasks_panel_count.js'
export * from './tasks_panel_empty.js'
export * from './robot_hud_battery.js'
export * from './robot_hud_task_section.js'
export * from './robot_hud_eta_remaining.js'
export * from './robot_hud_idle.js'
export * from './tasks_panel_loading.js'
export * from './tasks_panel_error.js'
export * from './tasks_panel_retry.js'
export * from './tasks_panel_dispatch_button.js'
export * from './tasks_panel_close.js'
export * from './tasks_status_queued.js'
export * from './tasks_status_standby.js'
export * from './tasks_status_underway.js'
export * from './tasks_status_delayed.js'
export * from './tasks_status_completed.js'
export * from './tasks_status_canceled.js'
export * from './tasks_status_killed.js'
export * from './tasks_status_failed.js'
export * from './tasks_category_patrol.js'
export * from './tasks_category_delivery.js'
export * from './tasks_category_clean.js'
export * from './tasks_unassigned.js'
export * from './tasks_cancel_button.js'
export * from './tasks_cancel_in_progress.js'
export * from './tasks_cancel_failed.js'
export * from './tasks_retry_button.js'
export * from './tasks_retry_in_progress.js'
export * from './tasks_retry_failed.js'
export * from './chat_button_label.js'
export * from './chat_panel_title.js'
export * from './chat_panel_subtitle.js'
export * from './chat_input_placeholder.js'
export * from './chat_send_button.js'
export * from './chat_send_loading.js'
export * from './chat_empty_state.js'
export * from './chat_clear_button.js'
export * from './chat_clear_confirm.js'
export * from './chat_close_button.js'
export * from './chat_dispatched_intro.js'
export * from './chat_dispatched_failed.js'
export * from './chat_dispatched_pending.js'
export * from './chat_dispatch_cap_reached.js'
export * from './chat_history_truncated.js'
export * from './chat_error_unauthorized.js'
export * from './chat_error_unavailable.js'
export * from './chat_error_unknown.js'
export * from './chat_tokens_label.js'
export * from './chat_world_reset_toast.js'
export * from './chat_suggestion_patrol.js'
export * from './chat_suggestion_floors.js'
export * from './chat_suggestion_stress.js'
export * from './chat_suggestion_delivery.js'
export * from './chat_dispatched_many_toast.js'
export * from './dispatch_title.js'
export * from './dispatch_close.js'
export * from './dispatch_fleet_label.js'
export * from './dispatch_fleet_auto.js'
export * from './dispatch_fleet_auto_hint.js'
export * from './dispatch_fleet_specific_hint.js'
export * from './dispatch_category_label.js'
export * from './dispatch_patrol_places_label.js'
export * from './dispatch_patrol_places_hint.js'
export * from './dispatch_patrol_rounds_label.js'
export * from './dispatch_delivery_pickup_label.js'
export * from './dispatch_delivery_dropoff_label.js'
export * from './dispatch_clean_zone_label.js'
export * from './dispatch_submit.js'
export * from './dispatch_cancel.js'
export * from './dispatch_no_capability.js'
export * from './dispatch_no_waypoints.js'
export * from './dispatch_pickup_unavailable.js'
export * from './dispatch_dropoff_unavailable.js'
export * from './dispatch_zone_unavailable.js'
export * from './dispatch_success.js'
export * from './level_switcher_label.js'
export * from './level_all.js'
export * from './campus_placeholder_title.js'
export * from './campus_placeholder_body.js'
export * from './shadows_label.js'
export * from './shadows_enable.js'
export * from './shadows_disable.js'
export * from './xray_label.js'
export * from './xray_enable.js'
export * from './xray_disable.js'
export * from './camera_reset.js'
export * from './camera_reset_label.js'
export * from './camera_unlock.js'
export * from './camera_unlock_label.js'
export * from './camera_unlock_3d.js'
export * from './hwaccel_title.js'
export * from './hwaccel_body.js'
export * from './hwaccel_link.js'
export * from './hwaccel_dismiss.js'
export * from './footer_designed_by.js'
export * from './footer_build_date.js'
export * from './language_switcher_label.js'
export * from './language_fr.js'
export * from './language_en.js'
export * from './language_ms_sg2.js'
export * from './singapore_motto.js'
export * from './camera_tutorial_label.js'
export * from './camera_tutorial_rotate.js'
export * from './camera_tutorial_pan.js'
export * from './camera_tutorial_zoom.js'
export * from './map_picker_legend.js'
export * from './map_picker_placeholder_badge.js'
export * from './map_office_description.js'
export * from './map_hotel_description.js'
export * from './map_clinic_description.js'
export * from './map_airport_terminal_description.js'
export * from './map_triple_h_description1.js'
export * from './map_battle_royale_description.js'
export * from './map_campus_description.js'
export * from './welcome_title.js'
export * from './welcome_intro.js'
export * from './welcome_phase_starting.js'
export * from './welcome_phase_waiting.js'
export * from './welcome_phase_rmf_initializing.js'
export * from './welcome_phase_rmf_loading.js'
export * from './welcome_phase_ready.js'
export * from './welcome_phase_error.js'
export * from './welcome_phase_lost.js'
export * from './welcome_elapsed.js'
export * from './rmf_degraded_title.js'
export * from './rmf_degraded_body.js'
export * from './rmf_degraded_retry_button.js'
export * from './rmf_degraded_retry_in_progress.js'
export * from './welcome_settings_label.js'
export * from './welcome_settings_description.js'
export * from './welcome_map_label.js'
export * from './welcome_map_description.js'
export * from './welcome_start_button.js'
export * from './welcome_start_button_waiting.js'
export * from './welcome_start_description.js'
export * from './backend_session_label.js'
export * from './backend_session_description.js'
export * from './backend_session_dns_label.js'
export * from './backend_session_dns_pending.js'
export * from './backend_session_ready_v1_note.js'
export * from './backend_session_retry.js'
export * from './backend_session_error_maintenance.js'
export * from './backend_session_error_initializing.js'
export * from './backend_session_error_capacity.js'
export * from './backend_session_error_quota.js'
export * from './backend_session_error_unauthorized.js'
export * from './backend_session_error_timeout.js'
export * from './backend_session_error_failed.js'
export * from './backend_session_error_missing.js'
export * from './backend_session_error_unknown.js'
export * from './backend_quota_label.js'
export * from './quota_used_label.js'
export * from './quota_updated_at.js'
export * from './quota_warning_low.js'
export * from './quota_exhausted_title.js'
export * from './quota_exhausted_message.js'
export * from './logout_button.js'
export * from './logout_in_progress.js'
export * from './heartbeat_unreachable_banner.js'
export * from './heartbeat_session_lost.js'
export * from './auth_error_access_denied_title.js'
export * from './auth_error_access_denied_body.js'
export * from './auth_error_access_denied_action.js'
export * from './welcome_links_title.js'
export * from './welcome_links_docs_label.js'
export * from './welcome_links_gitlab_label.js'
export * from './rmf_banner_label.js'
export * from './rmf_banner_starting.js'
export * from './rmf_banner_switching.js'
export * from './rmf_banner_connecting.js'
export * from './rmf_banner_retry.js'
export * from './rmf_banner_unknown_error.js'
export * from './settings_button_label.js'
export * from './chat_tokens_tooltip.js'
export * from './dispatch_dual_charger_title.js'
export * from './dispatch_dual_charger_badge.js'
export * from './scene_canvas_a11y.js'